import { makeStyles } from '@material-ui/core/styles';

import colors from '../../styles/settings/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginLeft: '19%',
    overflowX: 'hidden',
    height: '57vh !important',
    position: 'relative',
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    background: '#fff',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '63px',
    paddingRight: '10px',
    marginBottom: '19px',
  },
  totalGeral: {
    fontSize: '14px',
    fontWeight: 600,
    color: colors.white,
    border: `1px solid ${colors.sanMarino}`,
    borderRadius: '4px',
    padding: '8px 14px',
    backgroundColor: colors.sanMarino,
  },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '120px',
    height: '36px',
    padding: '0 12px',
    borderRadius: '2px',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': { background: '#9CB7C4', cursor: 'not-allowed' },
  },
  buttonAction: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    height: '36px',
    padding: '0 16px',
    borderRadius: '2px',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    marginLeft: '10px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': { background: '#9CB7C4', cursor: 'not-allowed' },
  },
  searchContainer: { alignItems: 'center' },
  item: {},
  statusChip: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
  },
  linkCell: {
    color: '#026894',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  errorLink: {
    color: '#C62828',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '13px',
  },
}));

export default useStyles;
